<span class="battery__container">
  @if (batteryPercentage > 80) {
    <i class="battery__icon fas fa-battery-full green"></i>
    <span class="battery__text">{{ batteryPercentage }}&#37;</span>
  } @else if (batteryPercentage > 20) {
    <i
      class="battery__icon fas gold"
      [ngClass]="{ 'fa-battery-three-quarters': batteryPercentage > 60,
                  'fa-battery-half': batteryPercentage > 30 && batteryPercentage <= 60,
                  'fa-battery-quarter': batteryPercentage <= 30  }">
    </i>
    <span class="battery__text">{{ batteryPercentage }}<small>&#37;</small></span>
  } @else {
    <i
      matTooltip="{{ 'headsetBatteryTooltip' | translate }}"
      class="battery__icon fas red"
      [ngClass]="{ 'fa-battery-quarter': batteryPercentage > 5,
                  'fa-battery-empty': batteryPercentage <= 5 }">
    </i>
    <span class="battery__text">{{ batteryPercentage }}<small>&#37;</small></span>
  }
</span>
